// core/services/captionsService.ts — video captions (1.27.60; server: apps/media/captions.py).
import { api } from '@/core/lib/apiClient';
import type { CaptionTrack } from '@/core/models/post';

export const captionsService = {
  /** The caption tracks of a video you can watch (or your own, before posting). */
  async list(videoId: string): Promise<CaptionTrack[]> {
    const res = await api<{ results?: CaptionTrack[] } | undefined>(`/videos/${videoId}/captions/`);
    return Array.isArray(res?.results) ? res.results : [];
  },

  /** One track's WebVTT text. */
  async file(videoId: string, language: string): Promise<string> {
    const res = await fetch(`/api/videos/${videoId}/captions/${encodeURIComponent(language)}/`, {
      credentials: 'same-origin',
      headers: { Accept: 'text/vtt' },
    });
    if (!res.ok) throw new Error(`captions ${res.status}`);
    return res.text();
  },

  /** Add or replace your captions for one language. */
  async upload(
    videoId: string,
    body: { language: string; label: string; source: CaptionTrack['source']; vtt: string },
  ): Promise<CaptionTrack> {
    return api<CaptionTrack>(`/media/videos/${videoId}/captions/`, { method: 'POST', body });
  },

  async remove(videoId: string, language: string): Promise<void> {
    await api(`/media/videos/${videoId}/captions/${encodeURIComponent(language)}/`, {
      method: 'DELETE',
    });
  },
};
